/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import Header from "../../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../../Components/Dashboard/Sidebar/Sidebar";
import FloatingLabelInput from "../../../../Components/floatingLabel/FloatingLabel";
import "../ResumeDisplay/ResumeDisplay.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Apiurl, GetToken } from "../../../../Utils/utils";
import axios from "axios";
import Select from "react-select";
import Loader from "../../../../Components/loader/loader";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./ResumeUploard.css";

const ResumeUploard = () => {
  const navigate = useNavigate();
  const [errorFirstName, setErrorFirstName] = useState(false);

  const [dummy, setDummy] = useState(false);
  const [errorMobile, setErrorMobile] = useState();
  const [errorEmail, setErrorEmail] = useState();
  const [errorCategory, setErrorCategory] = useState();
  const [errorSubCategory, setErrorSubCategory] = useState();
  const [errorSkills, setErrorSkills] = useState();
  const [errorExperience, setErrorExperience] = useState(false);
  const [errorFileuploder, setErrorFileuploder] = useState();

  const fileInputRef = useRef(null);

  const [showSidebar, setShowSidebar] = useState(true);
  const [loading, setLoading] = useState(false);
  const LoginToken = GetToken();
  const [departmentData, setDepartmentData] = useState([]);
  const [departmentId, setDepartmentId] = useState("");
  const [SubCategory, setSubCategoryy] = useState([]);

  const [expreinceeuserData, setExpreinceeuserData] = useState([]);

  const [profileAlldata, setProfileAllData] = useState({
    FirstName: "",
    Email: "",
    Mobile: "",
    Category: "",
    SubCategory: "",
    Skills: "",
    Experience: "",
    UrlLink: "",
  });

  const location = useLocation();
  const PrefiledData = location?.state;

  useEffect(() => {
    if (PrefiledData) {
      setProfileAllData((prevProfileAllData) => ({
        ...prevProfileAllData,
        FirstName: PrefiledData?.name,
        Email: PrefiledData?.email,
        Mobile: PrefiledData?.phone,
        Category: {
          label: PrefiledData?.categories?.name,
          value: PrefiledData?.categories?.id,
        },

        SubCategory: {
          label: PrefiledData?.subCategories?.designationName,
          value: PrefiledData?.subCategory,
        },
        Skills: PrefiledData?.skills,
        UrlLink: PrefiledData?.documentPath,
        Experience: {
          label: PrefiledData.experiences?.name,
          value: PrefiledData.experiences?.id,
        },
      }));
      setDepartmentId(PrefiledData?.categories?.id);
    }
  }, [PrefiledData]);

  const validate = () => {
    if (!profileAlldata?.FirstName) {
      setErrorFirstName("userFirstName");
      return false;
    }

    if (!profileAlldata?.Mobile) {
      setErrorMobile("userMobile");
      return false;
    }

    if (!profileAlldata?.Email) {
      setErrorEmail("userEmail");
      return false;
    }
    if (!profileAlldata?.Category) {
      setErrorCategory("userCategory");
      return false;
    }
    if (!profileAlldata?.SubCategory) {
      setErrorSubCategory("userSubCategory");
      return false;
    }
    if (!profileAlldata?.Skills) {
      setErrorSkills("userSkills"); 
      return false;
    }
    if (!profileAlldata?.Experience) {
      setErrorExperience("userExperience");
      return false;
    }
    if (!storeFile) {
      setErrorFileuploder("ErrorFileuplode");
      return false;
    }
    return true;
  };

  const handleImageChange = (e) => {
    if (storeFile) {
      setErrorFileuploder("");
    }
    const file = e.target.files[0];
    if (file) {
      setErrorFileuploder("");
      setStoreFile(file);
    }
  };

  const handleCancel = (e) => {
    setProfileAllData({
      FirstName: "",
      Email: "",
      Mobile: "",
      Category: "",
      SubCategory: "",
      Skills: "",
      UrlLink: "",
    });
    setErrorEmail("")
    setErrorExperience("")
    setErrorMobile("")
    setErrorCategory("")
    setErrorSubCategory("")
    setErrorSkills("")
    setErrorFirstName("")
    setErrorFileuploder("")
  };
  const [storeFile, setStoreFile] = useState(null);

  const handleResumeUploard = () => {
    if (!validate()) return;
    const formData = new FormData();

    if (PrefiledData) {
      // PrefiledData.Id;
      formData.append("Id", PrefiledData.id);
      formData.append("Name", profileAlldata.FirstName);
      formData.append("Phone", profileAlldata.Mobile);
      formData.append("Email", profileAlldata.Email);
      formData.append("Category", profileAlldata.Category?.value);
      formData.append("SubCategory", profileAlldata.SubCategory?.value);
      formData.append("Skills", profileAlldata.Skills);
      formData.append("Experience", profileAlldata?.Experience.value);
      formData.append("AttachmentDocument", storeFile);
    } else {
      formData.append("Name", profileAlldata.FirstName);
      formData.append("Phone", profileAlldata.Mobile);
      formData.append("Email", profileAlldata.Email);
      formData.append("Category", profileAlldata.Category?.value);
      formData.append("SubCategory", profileAlldata.SubCategory?.value);
      formData.append("Experience", profileAlldata.Experience?.value);
      formData.append("Skills", profileAlldata.Skills);
      formData.append("AttachmentDocument", storeFile);
    }
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
        "access-control-allow-origin": "*",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Cv/SaveCv`,

      data: formData,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          navigate("/Emp/ResumeDisplay");
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  const getDepartment = () => {
    setLoading(true);
    const token = GetToken();
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      url: `${Apiurl()}/Admin/GetDepartments`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        const finalData = data?.map((item) => ({
          label: item?.Name,
          value: item?.Id,
        }));
        setDepartmentData(finalData);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getDepartment();
  }, []);
  const handleDepartmentChange = (selectedOption) => {
    if (selectedOption?.label) {
      setErrorCategory("");
    }
    setDepartmentId(selectedOption?.value);
    setProfileAllData({ ...profileAlldata, Category: selectedOption });
  };

  const SubDepartment = (e) => {
    e?.preventDefault();
    setLoading(true);
    const LoginToken = GetToken();
    const data = {};
    data.DepartmentId = departmentId;
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/GetDesignations`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        const finalData = data?.map((item) => ({
          label: item?.DesignationName,
          value: item?.Id,
        }));
        setSubCategoryy(finalData);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  useEffect(() => {
    if (departmentId) {
      SubDepartment();
    }
  }, [departmentId]);

  const handleDesignationData = (selectedOption) => {
    if (selectedOption?.label) {
      setErrorSubCategory("");
    }
    setProfileAllData({ ...profileAlldata, SubCategory: selectedOption });
    // setDepartmentId(selectedOption?.value);
  };
  const handleUserExperiences = (selectedOption) => {
    if (selectedOption.label) {
      setErrorExperience("");
    }
    setProfileAllData({ ...profileAlldata, Experience: selectedOption });
  };
  const GetUserExperiences = () => {
    setLoading(true);
    const token = GetToken();
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      url: `${Apiurl()}/Cv/GetExperiences`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        const finalData = data.Result?.map((item) => ({
          label: item?.Name,
          value: item?.Id,
        }));

        setExpreinceeuserData(finalData);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    GetUserExperiences();
  }, []);
  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} dummy={dummy} setDummy={setDummy} />
        <section
          className={
            showSidebar
              ? "Resume-uploard-screen"
              : "Resume-uploard-screen-new"
          }
        >
          <div className="EMP-profile-all-icons">
            <div>
              <p className="Resume-Uploder-main-heading">Resume </p>
            </div>
            <div className="dashboiard-inner-header">
              <BiHomeAlt className="EMP-home-icon-header-inn" />
              <MdKeyboardArrowRight />
              <p> Resume </p>
              <MdKeyboardArrowRight />
              <p> Upload </p>
            </div>
          </div>
          <div className="EMP-Resume-main-container">
            <div className="EMP-Resume-outter-container">
              <div className="EMP-Resume-inner-container">
                <div className="EMP-profile-heading">
                  <p> Resume</p>
                </div>
                <div className="EMP-Resume-inner-box row">
                  {/* Name Field   */}
                  <div className="profile-inputs col-4">
                    <FloatingLabelInput
                      label="Name*"
                      value={profileAlldata?.FirstName}
                      onChange={(e) => {
                        setProfileAllData({
                          ...profileAlldata,
                          FirstName: e?.target?.value,
                        });
                        if (e?.target?.value) {
                          setErrorFirstName("");
                        }
                      }}
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorFirstName("userFirstName");
                        } else {
                          setErrorFirstName("");
                        }
                      }}
                    />
                    {errorFirstName === "userFirstName" ? (
                      <span className="contact_error-login">
                        Name is required.
                      </span>
                    ) : null}
                  </div>
                  {/* Phone Number Field  */}
                  <div className="profile-inputs col-4">
                    <FloatingLabelInput
                      label="Phone*"
                      maxLength="10"
                      value={profileAlldata.Mobile}
                      onChange={(e) => {
                        const inputMobile = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 10);
                        setProfileAllData({
                          ...profileAlldata,
                          Mobile: inputMobile,
                        });

                        if (inputMobile.length === 10) {
                          setErrorMobile("");
                        }
                      }}
                      onBlur={(e) => {
                        if (
                          !e?.target?.value ||
                          e?.target?.value.length !== 10
                        ) {
                          setErrorMobile("userMobile");
                        } else {
                          setErrorMobile("");
                        }
                      }}
                    />
                    {errorMobile === "userMobile" && (
                      <span className="contact_error-login">
                        {!profileAlldata.Mobile
                          ? "Phone number is required."
                          : profileAlldata.Mobile.length !== 10
                          ? "Phone number is invalid."
                          : null}
                      </span>
                    )}
                  </div>
                  {/* Email Field  */}
                  <div className="profile-inputs col-4">
                    <FloatingLabelInput
                      label="Email*"
                      value={profileAlldata?.Email?.trim()}
                      onChange={(e) => {
                        setProfileAllData({
                          ...profileAlldata,
                          Email: e?.target?.value,
                        });
                        if (e.target.value) {
                          setErrorEmail("");
                        }
                      }}
                      style={{ marginBottom: 0 }}
                      onBlur={(e) => {
                        const emailValue = e?.target?.value?.trim();
                        if (!emailValue) {
                          setErrorEmail("userEmail");
                        } else {
                          setErrorEmail("");
                        }
                      }}
                    />

                    {errorEmail === "userEmail" && (
                      <span className="contact_error-login">
                        Email is required.
                      </span>
                    )}
                  </div>
                  <div className="profile-inputs col-6">
                    <Select
                      classNamePrefix="prefix-department-forCv-screen"
                      placeholder="Category"
                      options={departmentData}
                      getOptionLabel={(option) => option?.label}
                      getOptionValue={(option) => option?.value}
                      value={
                        profileAlldata?.Category
                          ? {
                              value: profileAlldata?.Category?.value,
                              label: departmentData.find(
                                (item) =>
                                  item?.value ===
                                  profileAlldata?.Category?.value
                              )?.label,
                            }
                          : null
                      }
                      onBlur={(e) => {
                        if (!profileAlldata.Category) {
                          setErrorCategory("userCategory");
                        } else if (profileAlldata.Category) {
                          setErrorCategory("");
                        }
                      }}
                      onChange={(e) => handleDepartmentChange(e)}
                    />
                    {errorCategory === "userCategory" ? (
                      <span className="contact_error-login">
                        Category is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="profile-inputs col-6">
                    <Select
                      classNamePrefix="subdepartment-dropdown-forCv-Screen"
                      placeholder="Sub Categories"
                      value={
                        profileAlldata?.SubCategory
                          ? {
                              value: profileAlldata?.SubCategory?.value,
                              label: SubCategory?.find(
                                (item) =>
                                  item?.value ===
                                  profileAlldata?.SubCategory?.value
                              )?.label,
                            }
                          : null
                      }
                      options={SubCategory}
                      getOptionLabel={(option) => option?.label}
                      getOptionValue={(option) => option?.value}
                      onChange={(e) => handleDesignationData(e)}
                      onBlur={(e) => {
                        if (!profileAlldata?.SubCategory) {
                          setErrorSubCategory("userSubCategory");
                        } else if (profileAlldata?.SubCategory) {
                          setErrorSubCategory("");
                        }
                      }}
                    />
                    {errorSubCategory === "userSubCategory" ? (
                      <span className="contact_error-login">
                        SubCategory is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="profile-inputs col-6">
                    <FloatingLabelInput
                      label="Skills*"
                      value={profileAlldata.Skills}
                      onChange={(e) => {
                        setProfileAllData({
                          ...profileAlldata,
                          Skills: e?.target?.value,
                        });
                        if (e.target.value) {
                          setErrorSkills("");
                        }
                      }}
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorSkills("userSkills");
                        } else {
                          setErrorSkills("");
                        }
                      }}
                    />
                    {errorSkills === "userSkills" ? (
                      <span className="contact_error-login">
                        Skills is required.
                      </span>
                    ) : null}
                  </div>
                  <div className="profile-inputs col-6">
                    <Select
                      classNamePrefix="subdepartment-dropdown-forCv-Screen"
                      placeholder="Experiences"
                      value={
                        profileAlldata?.Experience
                          ? {
                              value: profileAlldata?.Experience?.value,
                              label: expreinceeuserData?.find(
                                (item) =>
                                  item?.value ===
                                  profileAlldata?.Experience?.value
                              )?.label,
                            }
                          : null
                      }
                      options={expreinceeuserData}
                      getOptionLabel={(options) => options?.label}
                      getOptionValue={(options) => options?.value}
                      onChange={(e) => handleUserExperiences(e)}
                      onBlur={(e) => {
                        if (!profileAlldata?.Experience) {
                          setErrorExperience("userExperience");
                        } else if (profileAlldata?.Experience) {
                          setErrorExperience("");
                        }
                      }}
                    />
                    {errorExperience === "userExperience" ? (
                      <span className="contact_error-login">
                        Experience is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="Resume-uploder-container col-6">
                    <label htmlFor="profileImage">CV Upload</label>
                    <div className="CV-Upload-Container">
                      <input
                        type="File"
                        id="profileImage"
                        ref={fileInputRef}
                        onChange={(e) => handleImageChange(e)}
                        onBlur={(e) => {
                          if (!storeFile) { 
                            setErrorFileuploder("ErrorFileuplode");
                          } else if(storeFile) {
                            setErrorFileuploder("");
                          }
                        }}
                      />
                    </div>
                    {errorFileuploder === "ErrorFileuplode" ? (
                      <span className="Setcv-uploder-error">
                        CV Upload is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="Resume-button-container">
                    <button
                      className="Resume-uploder-screen-sumbit-button"
                      onClick={() => handleResumeUploard("update")}
                    >
                      {/* Submit */}
                      {PrefiledData ? "Update" : "submit"}
                    </button>

                    <button
                      className="Resume-uploder-screen-Cancel-button"
                      onClick={() => handleCancel()}
                    >
                      {" "}
                      Cancel{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default ResumeUploard;
